import { render } from "./JoinedSection.vue?vue&type=template&id=7b4f8886"
import script from "./JoinedSection.vue?vue&type=script&lang=js"
export * from "./JoinedSection.vue?vue&type=script&lang=js"

import "./JoinedSection.vue?vue&type=style&index=0&id=7b4f8886&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__